import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSeoMeta } from '@unhead/react';
import { Home, RefreshCw, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

const quotes = [
  { text: "Peace comes from within. Do not seek it without.", author: "Buddha" },
  { text: "The present moment is filled with joy and happiness.", author: "Thích Nhất Hạnh" },
  { text: "Smile, breathe, and go slowly.", author: "Thích Nhất Hạnh" },
  { text: "Nature does not hurry, yet everything is accomplished.", author: "Lao Tzu" },
];

export default function DailyQuote() {
  const [quote, setQuote] = useState(quotes[0]);

  useSeoMeta({ title: 'Daily Quote - Zenstr' });

  useEffect(() => {
    const saved = localStorage.getItem('zenstr-quote');
    if (saved) setQuote(JSON.parse(saved));
  }, []);

  const newQuote = () => {
    const q = quotes[Math.floor(Math.random() * quotes.length)];
    setQuote(q);
    localStorage.setItem('zenstr-quote', JSON.stringify(q));
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border/50">
        <div className="container mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-2xl">🧘‍♀️</span>
            <span className="font-display font-semibold">Zenstr</span>
          </div>
          <Link to="/">
            <Button variant="ghost" size="sm"><Home className="w-4 h-4 mr-2" /> Dashboard</Button>
          </Link>
        </div>
      </header>

      <main className="container mx-auto px-6 py-16 max-w-3xl">
        <div className="space-y-12">
          <div className="text-center space-y-2">
            <Sparkles className="w-16 h-16 mx-auto text-accent" />
            <h1 className="text-4xl md:text-5xl font-display font-bold">Daily Inspiration</h1>
          </div>

          <Card className="p-12 md:p-16 text-center space-y-8 bg-card/50">
            <blockquote className="text-3xl md:text-4xl font-serif italic leading-relaxed">
              "{quote.text}"
            </blockquote>
            <p className="text-xl text-muted-foreground">— {quote.author}</p>
          </Card>

          <div className="flex justify-center">
            <Button onClick={newQuote} size="lg" variant="outline">
              <RefreshCw className="w-5 h-5 mr-2" /> New Quote
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
}
